import { ReactNode, ButtonHTMLAttributes } from 'react';
import * as S from "./styles";

import { LoadingSpinner } from 'components/LoadingSpinner';

interface Props {
  title: string;
  onClick?: any;
  className?: any;
  type?: "submit" | "button";
  disabled?: boolean;
}


interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: ReactNode;
  title?: string;
  isFetching?: boolean;
  variant?: S.ButtonVariant;
}

export function Button({
  children,
  isFetching = false,
  variant = 'primary',
  title,
  ...rest
}: ButtonProps) {
  return (
    <S.ButtonWrapper
      isFetching={isFetching}
      variant={variant}
      {...rest}
      disabled={isFetching || rest.disabled}
    >
      {children ?? title}

      {isFetching && (
        <LoadingSpinner color="var(--black-200)" />
      )}
    </S.ButtonWrapper>
  )
}

function OldButton({ title, onClick, type, disabled, className }: Props) {
  return (
    <S.Container
      className={className}
      disabled={disabled}
      type={type}
      onClick={onClick}
    >
      {title}
    </S.Container>
  );
}

export function EditButton({ title, onClick, type }: Props) {
  return (
    <S.EditButton type={type} onClick={onClick}>
      {title}
    </S.EditButton>
  );
}

export function ReportButton({ title, onClick }: Props) {
  return <S.ReportButton onClick={onClick}>{title}</S.ReportButton>;
}

export function NextButton({ title, onClick }: Props) {
  return <S.NextButton onClick={onClick}>{title}</S.NextButton>;
}

export function ApprovalButton({ title, onClick, type }: Props) {
  return (
    <S.ApprovalButton type={type} onClick={onClick}>
      {title}
    </S.ApprovalButton>
  );
}

export function RefuseButton({ title, onClick, type }: Props) {
  return (
    <S.RefuseButton type={type} onClick={onClick}>
      {title}
    </S.RefuseButton>
  );
}

export default OldButton;
